import React from 'react';
import _ from 'lodash';
import {Collapse, FormControls} from '../../../../shared/library';
import {InfoIcon} from '../../../../shared/Svgs';
import SuggestedEntries from './SuggestedEntries';
import {
  bindMethods,
  setRef,
} from '../../../../shared/utilities/componentHelpers';
import {validateEmail} from '../../../../shared/utilities/validationHelpers';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {buildUrl} from '../../../../shared/utilities/urlHelpers';
import {sanitizeText} from '../../../../../appModules/utilities/formatHelpers';
import * as CONSTANTS from '../../../../shared/utilities/constants';
import styles from './css/CondolenceEntry.styl';
import MediaBar from './MediaBar';
import appConfig from '../../../../../appConfig/AppConfig';

const conf = appConfig();
const {Button, SelectList, TextArea, TextInput} = FormControls;
const {
  ENTRY_PANEL_KEY,
  ENTRY_TEXT_AREA_KEY,
  FAQ_BASE_URL,
  GUIDELINES_BASE_URL,
  MEDIA_TYPES,
  PERSON_SIGNUP_KEY,
  SUGGESTED_ENTRY_KEY,
} = CONSTANTS;

/**
 * Condolence Entry module for Guestbook
 * @class CondolenceEntry
 */
class CondolenceEntry extends React.Component {
  static propTypes = {
    allowPhotos: React.PropTypes.bool,
    allowVideos: React.PropTypes.bool,
    condolenceError: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.bool,
    ]),
    firstName: React.PropTypes.string,
    handleEditOverlay: React.PropTypes.func,
    handleEntryToggle: React.PropTypes.func,
    handleCandleToggle: React.PropTypes.func,
    handleDisplayError: React.PropTypes.func,
    handleMediaCollection: React.PropTypes.func,
    handleSubmit: React.PropTypes.func,
    isCandleLit: React.PropTypes.bool,
    isNFGB: React.PropTypes.bool,
    isSubmitting: React.PropTypes.bool,
    lastName: React.PropTypes.string,
    location: React.PropTypes.object,
    mediaCollection: React.PropTypes.array,
    mutationStatus: React.PropTypes.object,
    obitFirstName: React.PropTypes.string,
    showCollection: React.PropTypes.bool,
    sourceId: React.PropTypes.number,
  };

  /**
   * CondolenceEntry Component constructor
   * @param  {Object} props Passed in properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    this.mobileBreakPoint = 415;
    this.textOptions = {
      mobile: 'What would you like to say...',
      firstName: `What would you like to say about ${props.firstName}?`,
      default: 'Share a memory or condolence to the guest book.',
    };

    this.state = {
      city: '',
      email: '',
      entry: '',
      errors: {},
      firstName: '',
      hasCandle: '',
      isExpanded: _.size(props.mediaCollection) !== 0,
      lastName: '',
      photos: [],
      relationship: 'none',
      state: 0,
      hasPersonAlertRequest: !props.isNFGB,
      hasPersonAlertCompleted: false,
      promptText: this.textOptions.mobile,
      showSignupToggle: true,
      signupStyle: {
        visibility: 'hidden',
        display: 'block',
      },
      tooltipStyles: {},
    };

    this.candleUrl = `${buildUrl(
      conf.environmentalUrl.cacheUrl,
      'globalcontent/gbmementos/candle.jpg'
    )}`;
    this.isClient = typeof window !== 'undefined';

    this.names = _.compact([props.firstName, props.lastName]);

    /* refs */
    this[ENTRY_PANEL_KEY] = null;
    this[ENTRY_TEXT_AREA_KEY] = null;
    this[PERSON_SIGNUP_KEY] = null;
    this[SUGGESTED_ENTRY_KEY] = null;
    this.setRefEntryPanel = _.partial(setRef, _, ENTRY_PANEL_KEY, this);
    this.setRefTextArea = _.partial(setRef, _, ENTRY_TEXT_AREA_KEY, this);
    this.setRefPersonSignUp = _.partial(setRef, _, PERSON_SIGNUP_KEY, this);
    this.setRefSuggestedEntries = _.partial(
      setRef,
      _,
      SUGGESTED_ENTRY_KEY,
      this
    );

    this.guidelinesLink = this.getLink(
      GUIDELINES_BASE_URL,
      props.sourceId,
      this.names
    );
    this.faqLink = this.getLink(FAQ_BASE_URL, props.sourceId, this.names);

    this.hasEntryFocusEventFired = false;
    this.isClient = typeof window !== 'undefined';

    /* selectlist options */
    this.relationshipOptions = [
      {name: 'Choose A Relationship', value: 'none'},
      {name: 'Friend', value: 'friend'},
      {name: 'Family', value: 'family'},
      {name: 'Coworker', value: 'coworker'},
      {name: 'Classmate', value: 'classmate'},
      {name: 'Neighbor', value: 'neighbor'},
      {name: 'Acquaintance', value: 'acquaintance'},
      {name: 'Student', value: 'student'},
      {name: 'Teacher', value: 'teacher'},
      {name: 'Served in the Military together', value: 'military'},
      {name: 'Significant Other', value: 'significant_other'},
      {name: 'Spouse', value: 'spouse'},
      {name: 'Brother', value: 'brother'},
      {name: 'Sister', value: 'sister'},
      {name: 'Daughter', value: 'daughter'},
      {name: 'Son', value: 'son'},
      {name: 'Grandchild', value: 'grandchild'},
      {name: 'Mother', value: 'mother'},
      {name: 'Father', value: 'father'},
      {name: 'Grandparent', value: 'grandparent'},
    ];

    this.states = [
      {value: 0, name: 'State/Province'},
      {value: 1, name: 'Alberta'},
      {value: 2, name: 'Alaska'},
      {value: 3, name: 'Alabama'},
      {value: 4, name: 'Arkansas'},
      {value: 5, name: 'Arizona'},
      {value: 6, name: 'British Columbia'},
      {value: 7, name: 'California'},
      {value: 8, name: 'Colorado'},
      {value: 9, name: 'Connecticut'},
      {value: 10, name: 'District of Columbia'},
      {value: 11, name: 'Delaware'},
      {value: 12, name: 'Florida'},
      {value: 13, name: 'Georgia'},
      {value: 14, name: 'Hawaii'},
      {value: 15, name: 'Iowa'},
      {value: 16, name: 'Idaho'},
      {value: 17, name: 'Illinois'},
      {value: 18, name: 'Indiana'},
      {value: 19, name: 'Kansas'},
      {value: 20, name: 'Kentucky'},
      {value: 21, name: 'Louisiana'},
      {value: 22, name: 'Massachusetts'},
      {value: 23, name: 'Manitoba'},
      {value: 24, name: 'Maryland'},
      {value: 25, name: 'Maine'},
      {value: 26, name: 'Michigan'},
      {value: 27, name: 'Minnesota'},
      {value: 28, name: 'Missouri'},
      {value: 29, name: 'Mississippi'},
      {value: 30, name: 'Montana'},
      {value: 32, name: 'New Brunswick'},
      {value: 33, name: 'North Carolina'},
      {value: 34, name: 'North Dakota'},
      {value: 35, name: 'Nebraska'},
      {value: 37, name: 'New Hampshire'},
      {value: 38, name: 'New Jersey'},
      {value: 36, name: 'Newfoundland'},
      {value: 39, name: 'New Mexico'},
      {value: 40, name: 'Nova Scotia'},
      {value: 41, name: 'Northwest Territories'},
      {value: 42, name: 'Nunavut'},
      {value: 43, name: 'Nevada'},
      {value: 44, name: 'New York'},
      {value: 45, name: 'Ohio'},
      {value: 46, name: 'Oklahoma'},
      {value: 47, name: 'Ontario'},
      {value: 48, name: 'Oregon'},
      {value: 49, name: 'Pennsylvania'},
      {value: 50, name: 'Prince Edward Island'},
      {value: 51, name: 'Quebec'},
      {value: 52, name: 'Rhode Island'},
      {value: 53, name: 'South Carolina'},
      {value: 54, name: 'South Dakota'},
      {value: 55, name: 'Saskatchewan'},
      {value: 56, name: 'Tennessee'},
      {value: 57, name: 'Texas'},
      {value: 58, name: 'Utah'},
      {value: 59, name: 'Virginia'},
      {value: 60, name: 'Vermont'},
      {value: 61, name: 'Washington'},
      {value: 62, name: 'Wisconsin'},
      {value: 63, name: 'West Virginia'},
      {value: 64, name: 'Wyoming'},
      {value: 65, name: 'Yukon Territory'},
      {value: 183, name: 'American Samoa'},
      {value: 179, name: 'Guam'},
      {value: 185, name: 'Marshall Islands'},
      {value: 184, name: 'Micronesia'},
      {value: 182, name: 'Northern Marianas'},
      {value: 186, name: 'Palau'},
      {value: 180, name: 'Puerto Rico'},
      {value: 181, name: 'U.S. Virgin Islands'},
      {value: 205, name: 'U.S. Minor Outlying Islands'},
    ];

    bindMethods(this, [
      'clearForm',
      'handleEntryFocus',
      'handleInputChange',
      'handleResize',
      'handleSubmit',
      'setRef',
      'setSignupStyle',
      'setTooltipStyles',
      'toggleEmailSignUp',
      'setSuggestedEntry',
    ]);
  }

  /**
   * Lifecycle method
   * @return {undefined} Returns nothing
   */
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('orientationchange', this.handleResize);

    this.setPromptText(this.props.firstName, this.textOptions);

    this.setSignupStyle(
      this.isClient,
      this.state.isExpanded,
      this.props.isNFGB,
      this.state.signupStyle
    );
  }

  /**
   * Lifecycle method - checks if done fetching data from Relay
   * @param  {Object} nextProps The new props
   * @return {Undefined} Returns nothing
   */
  componentWillReceiveProps(nextProps) {
    if (_.size(nextProps.mediaCollection) !== 0) {
      this.setState({isExpanded: true}, () => {
        this.setSignupStyle(
          this.isClient,
          this.state.isExpanded,
          this.props.isNFGB,
          this.state.signupStyle
        );
      });
    }

    const alertMutationStatus = _.get(nextProps, 'mutationStatus.alert');

    if (_.isNumber(alertMutationStatus)) {
      if (alertMutationStatus > 0) {
        this.setState({
          hasPersonAlertRequest: false,
          hasPersonAlertCompleted: true,
          showSignupToggle: false,
        });
      }
    }
  }

  /**
   * Lifecycle method
   * @return {Undefined} Returns nothing
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('orientationchange', this.handleResize);
  }

  /**
   * External method for cleaning the form
   * @return {Undefined} Returns nothing
   */
  clearForm() {
    this.setState(
      {
        city: '',
        email: '',
        entry: '',
        firstName: '',
        lastName: '',
        isExpanded: false,
        relationship: 'none',
        state: 0,
      },
      () => {
        this.props.handleEntryToggle(
          this.state.isExpanded,
          _.partial(
            this.setSignupStyle,
            this.isClient,
            this.state.isExpanded,
            this.props.isNFGB,
            this.state.signupStyle
          )
        );
      }
    );
    this.props.handleMediaCollection(null);

    const resetCandle = true;

    this.props.handleCandleToggle(resetCandle);
    this[SUGGESTED_ENTRY_KEY].resetEntries();
  }

  /**
   * Sets the entry state with the suggested entry
   * @param  {string}    entry the suggested entry
   * @return {Undefined} Returns nothing
   */
  setSuggestedEntry(entry) {
    this.setState({entry}, () => {
      this.handleEntryFocus();
      this.handleEntryUpdate();
    });
  }

  /**
   * Closes the entry form
   * @return {Undefined} Returns nothing
   */
  closeForm() {
    if (this.state.entry === '') {
      this.setState({isExpanded: false}, () => {
        this.props.handleEntryToggle(
          this.state.isExpanded,
          _.partial(
            this.setSignupStyle,
            this.isClient,
            this.state.isExpanded,
            this.props.isNFGB,
            this.state.signupStyle
          )
        );
      });
    }
  }

  /**
   * Returns link for faq
   * @param  {String} baseUrl  The base url for the link
   * @param  {String} sourceId  Person's guest book id
   * @param  {Array}  names Person's first and/or last name
   * @return {String} Returns the formatted url
   */
  getLink(baseUrl, sourceId, names) {
    let formattedNameParam = '';

    if (!_.isEmpty(names)) {
      const formattedName = names.join('-').toLowerCase();

      formattedNameParam = `n=${formattedName}&`;
    }

    return `${baseUrl}?${formattedNameParam}pid=${sourceId}`;
  }

  /**
   * Gets the text for the entry prompt
   * @param  {string} firstName   The first name
   * @param  {object} textOptions variations of the entry placeholder text
   * @return {undefined} returns nothing, sets state
   */
  setPromptText(firstName, textOptions) {
    let promptText = textOptions.mobile;

    if (this.isClient) {
      const isMobileSize = window.innerWidth < this.mobileBreakPoint;

      if (!isMobileSize) {
        promptText = textOptions[firstName ? 'firstName' : 'default'];
      }
    }

    if (this.state.promptText !== promptText) {
      this.setState({promptText});
    }
  }

  /**
   * Handles when focus happens on the entry
   * @return {undefined} Returns nothing
   */
  handleEntryFocus() {
    const isExpanded = this.state.isExpanded;

    if (!isExpanded) {
      this.setState({isExpanded: true}, () => {
        this.props.handleEntryToggle(
          this.state.isExpanded,
          _.partial(
            this.setSignupStyle,
            this.isClient,
            this.state.isExpanded,
            this.props.isNFGB,
            this.state.signupStyle
          )
        );
      });
    }

    const _textArea = _.get(this[ENTRY_TEXT_AREA_KEY], '_textArea', {});

    if (_.isFunction(_textArea.focus)) {
      _textArea.focus();
    }

    this.handleEntryFocusEvent();
  }

  /**
   * Upon foucs, fire the ga event
   * @return {undefined} Returns nothing
   */
  handleEntryFocusEvent() {
    if (!this.hasEntryFocusEventFired) {
      this.hasEntryFocusEventFired = true;
      getGATags({
        eventCategory: 'bypage_person',
        eventAction: 'sign_guest_book_gbheader',
        eventLabel: 'onpage',
      });
    }
  }

  /**
   * Handles when the entry text area updates to adjust the height
   * @return {Undefined} Returns nothing
   */
  handleEntryUpdate() {
    const textArea = _.get(this, '_entryTextArea._textArea');

    if (textArea) {
      textArea.style.height = 'auto';
      textArea.style.height = `${textArea.scrollHeight}px`;
    }
  }

  /**
   * Handle an input change
   * @param  {Object} e The Event object
   * @param  {String} key The state key
   * @return {Undefined} Returns nothing
   */
  handleInputChange(e, key) {
    const value = e.target.value;
    const stateObj = {};

    stateObj[key] = value;
    this.setState(stateObj, () => {
      if (key === 'entry') {
        this.handleEntryUpdate();
      }
    });

    this[SUGGESTED_ENTRY_KEY].resetEntries();
  }

  /**
   * Resize handler
   * @return {Undefined} Returns nothing
   */
  handleResize() {
    if (!this.state.mediaUpload) {
      this.handleEntryUpdate();
    }

    this.setPromptText(this.props.firstName, this.textOptions);
    this.setSignupStyle(
      this.isClient,
      this.state.isExpanded,
      this.props.isNFGB,
      this.state.signupStyle
    );
  }

  /**
   * sets the style of the email signup input element
   * @param   {boolean}   isClient      is window available
   * @param   {boolean}   isExpanded    is the entry expanded
   * @param   {boolean}   isNFGB        is the page a national featured guestbook
   * @param   {object}    currentStyle  the current state of the signup style
   * @return  {undefined} returns nothing
   */
  setSignupStyle(isClient, isExpanded, isNFGB, currentStyle) {
    if (isClient) {
      const display = currentStyle.display;
      const visibility = currentStyle.visibility;
      let style = {};

      if (isExpanded && !isNFGB && this.state.showSignupToggle) {
        style = {
          visibility: 'visible',
          display: 'block',
        };

        if (display !== style.display || visibility !== style.visibility) {
          this.setState({signupStyle: style});
        }
      } else {
        const stackPoint = 1017;

        style = {
          visibility: 'hidden',
          display: window.innerWidth < stackPoint ? 'none' : 'block',
        };

        if (display !== style.display || visibility !== style.visibility) {
          this.setState({signupStyle: style});
        }
      }
    }
  }

  /**
   * Strips html and replace carriage returns with <br /> tags
   * @method sanitizeMessage
   * @param  {string} message - user submitted condolence entry
   * @return {string} returns the cleaned message
   */
  sanitizeMessage(message) {
    return _.isString(message) ? sanitizeText(
          message.replace(/\r\n|\r|\n/g, '<br />'),
          ['br']
        ) : '';
  }

  /**
   * Handles condolence submission
   * @param   {object} e  the Event object
   * @return  {undefined} returns nothing
   */
  handleSubmit(e) {
    e.preventDefault();

    /* add full validation in (future) */
    const isValidEntry = this.isValidEntry(
      this.state.entry,
      this.state.firstName,
      this.state.lastName,
      this.props.mediaCollection
    );

    const videoId =
      !_.isEmpty(this.props.mediaCollection) &&
      _.get(this.props, 'mediaCollection[0].mediaType') === MEDIA_TYPES.video &&
      _.get(this.props, 'mediaCollection[0].id');

    const videoCaption = videoId
      ? _.get(this.props, 'mediaCollection[0].caption', false)
      : false;

    const pictures =
      !_.isEmpty(this.props.mediaCollection) && !videoId
        ? this.props.mediaCollection.map(item => ({
            url: item.url,
            caption: this.sanitizeMessage(item.caption),
            width: item.width,
            height: item.height,
          }))
        : [];

    const submissionData = {
      message: this.sanitizeMessage(this.state.entry),
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      relationship:
        this.state.relationship === 'none' ? '' : this.state.relationship,
      city: this.state.city,
      stateId: parseInt(this.state.state, 10),
      videoId,
      videoCaption: videoCaption ? this.sanitizeMessage(videoCaption) : false,
    };

    const hasPersonAlertRequest =
      _.get(this.props, 'location.query.pid') &&
      this.state.email &&
      this.props.sourceId &&
      this.state.hasPersonAlertRequest;

    let personAlert = null;

    if (hasPersonAlertRequest) {
      personAlert = {
        personId: this.props.location.query.pid,
        email: this.state.email,
        guestBookId: this.props.sourceId,
      };
    }

    const isInvalidPersonAlert =
      !this.state.email && this.state.hasPersonAlertRequest;
    const isInvalidEmail = this.state.email && !validateEmail(this.state.email);
    const isValideSubmission =
      isValidEntry &&
      !isInvalidPersonAlert &&
      !isInvalidEmail &&
      _.isFunction(this.props.handleSubmit);

    if (isInvalidEmail || isInvalidPersonAlert) {
      this.props.handleDisplayError('invalidEmail');
    }

    if (isValideSubmission) {
      this.props.handleSubmit(submissionData, pictures, personAlert);
    }
  }

  /**
   * Checks if entry is valid for submission - can be fleshed more out later
   * @param  {String}  entry The entry
   * @param  {String}  firstName The first name field
   * @param  {String}  lastName  The last name field
   * @param  {Array}  mediaCollection  The mediaCollection array
   * @return {Boolean} If the form can be submitted
   */
  isValidEntry(entry, firstName, lastName, mediaCollection) {
    return (
      !_.isEmpty(_.trim(entry)) ||
      !_.isEmpty(_.trim(firstName)) ||
      !_.isEmpty(_.trim(lastName)) ||
      !_.isEmpty(mediaCollection)
    );
  }

  /**
   * Toggles the person alert request
   * @return {undefined} returns nothing
   */
  toggleEmailSignUp() {
    this.setState(prevState => ({
      hasPersonAlertRequest: !prevState.hasPersonAlertRequest,
    }));
  }

  /**
   * Sets styles for tooltip
   * @return {undefined} Returns nothing
   */
  setTooltipStyles() {
    const element = this[PERSON_SIGNUP_KEY];

    if (element) {
      const selfRect = element.getBoundingClientRect();

      this.setState({
        tooltipStyles: {
          display: 'block',
          bottom: `${selfRect.height + 10}px`,
        },
      });
    }
  }

  /**
   * React Component render.
   * @return {JSX} Condolence Entry rendered.
   */
  render() {
    const baseId = 'CondolenceEntry';
    const {condolenceError, isSubmitting, mediaCollection} = this.props;

    const isValidEntry = this.isValidEntry(
      this.state.entry,
      this.state.firstName,
      this.state.lastName,
      mediaCollection
    );

    return (
      <div className={styles.Entry}>
        {this.props.mediaCollection ? (
          <MediaBar
            handleEditOverlay={this.props.handleEditOverlay}
            mediaCollection={this.props.mediaCollection}
            showCollection={this.props.showCollection}
          />
        ) : null}
        <div className={styles.panel} ref={this.setRefEntryPanel}>
          <img
            className={this.props.isCandleLit ? '' : styles.hideCandle}
            src={this.candleUrl}
          />
          <div className={this.props.isCandleLit ? styles.isCandleLit : ''}>
            <TextArea
              className={styles.textArea}
              handleChange={_.partial(this.handleInputChange, _, 'entry')}
              handleFocus={this.handleEntryFocus}
              id={baseId}
              placeholder={this.state.promptText}
              ref={this.setRefTextArea}
              value={this.state.entry}
            />
          </div>
          <SuggestedEntries
            ref={this.setRefSuggestedEntries}
            setSuggestedEntry={this.setSuggestedEntry}
          />
          <Collapse in={this.state.isExpanded}>
            <div
              aria-hidden={!this.state.isExpanded}
              className={styles.panelContent}
            >
              <TextInput
                className={styles.action}
                handleChange={_.partial(this.handleInputChange, _, 'firstName')}
                id={`${baseId}_firstName`}
                isInvalid={this.state.errors.firstName}
                name="firstName"
                placeholder="First Name"
                value={this.state.firstName}
              />
              <TextInput
                className={styles.action}
                handleChange={_.partial(this.handleInputChange, _, 'lastName')}
                id={`${baseId}_lastName`}
                isInvalid={this.state.errors.lastName}
                name="lastName"
                placeholder="Last Name"
                value={this.state.lastName}
              />
              <SelectList
                className={styles.action}
                defaultValue={this.relationshipOptions[0].value}
                handleChange={_.partial(
                  this.handleInputChange,
                  _,
                  'relationship'
                )}
                id={`${baseId}_relationship`}
                isInvalid={this.state.errors.relationship}
                name="relationship"
                options={this.relationshipOptions}
                value={this.state.relationship}
              />
              <TextInput
                className={styles.action}
                handleChange={_.partial(this.handleInputChange, _, 'city')}
                id={`${baseId}_city`}
                isInvalid={this.state.errors.city}
                name="city"
                placeholder="City"
                value={this.state.city}
              />
              <SelectList
                className={styles.action}
                defaultValue={this.states[0].value}
                handleChange={_.partial(this.handleInputChange, _, 'state')}
                id={`${baseId}_state`}
                isInvalid={this.state.errors.state}
                name="state"
                options={this.states}
                value={this.state.state}
              />
              <TextInput
                className={styles.action}
                handleChange={_.partial(this.handleInputChange, _, 'email')}
                id={`${baseId}_email`}
                isInvalid={this.state.errors.email}
                name="email"
                placeholder={
                  this.state.hasPersonAlertRequest
                    ? 'Email Address'
                    : 'Email Address (optional)'
                }
                type="email"
                value={this.state.email}
              />
            </div>
          </Collapse>
          <div className={styles.lowerPanel}>
            <div className={styles.emailSignUp} style={this.state.signupStyle}>
              <input
                className={styles.emailCheckBox}
                defaultChecked
                id="emailSignUp"
                onChange={this.toggleEmailSignUp}
                type="checkbox"
              />
              <label htmlFor="emailSignUp">
                Get email updates for this page
                <span
                  onMouseOver={this.setTooltipStyles}
                  ref={this.setRefPersonSignUp}
                >
                  {' '}
                  <InfoIcon />
                  <aside style={this.state.tooltipStyles}>
                    <div className={styles.arrow} />
                    <p>
                      Get email updates about{' '}
                      <span>{this.names.join(' ')}</span> delivered directly to
                      your inbox.
                    </p>
                  </aside>
                </span>
              </label>
            </div>
            <div className={styles.buttonGroup}>
              {this.state.isExpanded ? (
                <Button
                  btnType="primary"
                  className={styles.cancel}
                  disabled={isSubmitting}
                  handleClick={this.clearForm}
                >
                  Cancel
                </Button>
              ) : null}
              <Button
                btnType="primary"
                className={styles.submit}
                disabled={!isValidEntry || isSubmitting}
                handleClick={this.handleSubmit}
                id={`${baseId}_submit`}
              >
                Submit
              </Button>
            </div>
            <div className={styles.guidelines}>
              <a href={this.guidelinesLink} target="_blank">
                Posting Guidelines
              </a>
              <span className={styles.divider}>|</span>
              <a href={this.faqLink} target="_blank">
                FAQ
              </a>
            </div>
          </div>
          <div className={styles.clearFix} />
        </div>
        {condolenceError ? (
          <div>
            <p className={styles.errorMessage}>
              <span className={styles.errorIcon}>i</span>&nbsp;{' '}
              {condolenceError}
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default CondolenceEntry;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/CondolenceEntry.js